/**
 * Most options an admin picker lists at once. The pickers hold every user / broker group,
 * so they show the first matches and a "type to narrow" row instead of rendering them all.
 */
export const ADMIN_PICKER_OPTION_LIMIT = 50;
